import SeamlessImmutable from 'seamless-immutable';
import { ProductInfoActionsType } from './productinfo.actions';
import ProductInfoActionTypesEnum from './model/ProductInfoActionTypesEnum';
import { IProductInfoPostInDTO } from '../../repository/jago/model/input/IProductInfoPostInDTO';

export interface IProductInfoInterface {
  posts: {
    data: IProductInfoPostInDTO[];
  },
  selectedPost: {
    data: IProductInfoPostInDTO | {};
  },
  vashoManual: {
    data: IProductInfoPostInDTO[];
  },
  developersPosts: {
    data: IProductInfoPostInDTO[];
  },
  iseoTrainingMaterials: {
    data: IProductInfoPostInDTO[];
  },
}

const initialState = SeamlessImmutable<IProductInfoInterface>({
  posts: {
    data: []
  },
  selectedPost: {
    data: {}
  },
  vashoManual: {
    data: []
  },
  developersPosts: {
    data: []
  },
  iseoTrainingMaterials: {
    data: []
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state: SeamlessImmutable.ImmutableObject<IProductInfoInterface> = initialState, action: ProductInfoActionsType) {
  switch (action.type) {
    case ProductInfoActionTypesEnum.SAVE_POSTS:
      return state.setIn(['posts', 'data'], action.payload);
    case ProductInfoActionTypesEnum.SET_SELECTED_POST:
      return state.setIn(['selectedPost', 'data'], action.payload);
    case ProductInfoActionTypesEnum.SAVE_VASHO_MANUAL:
      return state.setIn(['vashoManual', 'data'], action.payload);
    case ProductInfoActionTypesEnum.SAVE_DEVELOPERS_POSTS:
      return state.setIn(['developersPosts', 'data'], action.payload);
    case ProductInfoActionTypesEnum.SAVE_ISEO_TRAINING_MATERIALS:
      return state.setIn(['iseoTrainingMaterials', 'data'], action.payload);
    default:
      return state;
  }
}
